export enum EEnvironments {
  DEV = 'dev',
  SANDBOX = 'sandbox',
  STAGE = 'stage',
  PROD = 'prod',
}

export enum AccountType {
  INDIVIDUAL = 1,
  JOINT_TENANT = 2,
  OTHER = 3,
  COLLEGE_SAVINGS = 4,
  ROTH_ROLLOVER_IRA = 5,
  TRADITIONAL_IRA = 6,
  ROTH_IRA = 7,
  ROLLOVER_IRA = 8,
  EDUCATION_SAVINGS_ACCOUNT = 9,
  UGMA_UTMA = 10,
  TRUST = 11,
  CORPORATE = 12,
  RETIREMENT_PLAN_403 = 13,
  RETIREMENT_PLAN_401K = 14,
  RETIREMENT_PLAN_401K_FUND_REACH = 16,
  SEP_IRA = 17,
  SIMPLE_IRA = 18,
  KEOGH = 19,
  PROFIT_SHARING_PLAN = 20,
  MONEY_PURCHASE_PENSION_PLAN = 21,
  RETIREMENT_PLAN_457 = 22,
  RETIREMENT_PLAN_401A = 23,
  NON_QUALIFIED_RPS = 24,
  DEFINED_BENEFIT = 25,
  TRANSFER_ON_DEATH = 26,
  NON_PROFIT_ORGANIZATION = 27,
  NON_FIDUCIARY_RETIREMENT_PLAN = 28,
  GUARANTEED_INVESTMENT_CONTRACT = 29,
  SAR_SEP = 31,
  SIM_401K = 34,
  TRADITIONAL_IRA_DECEASED_BENE = 35,
  ROTH_IRA_DECEASED_BENE = 36,
  ROTH_IRA_DECEASED = 37,
  TRADITIONAL_IRA_DECEASED = 38,
  INDIVIDUAL_401K = 39,
  POWER_OF_ATTORNEY = 40,
  ESTATE = 41,
  RETIREMENT_PLAN_BENE_DUE_TO_DEATH = 42,
  RETIREMENT_PLAN_DECEASED = 43,
  FIS = 44,
  ORGANIZATION = 46,
  RETIREMENT_PLAN = 47,
  JOHN_HANCOCK_GUARDIAN = 48,
  JOHN_HANCOCK_UGMA_UTMA = 49,
  JOHN_HANCOCK_TRUST = 50,
  UNDEFINED = 99,
  INHERITED_IRA = 100,
  ROTH_INHERITED_IRA = 101,
}

export const AccountTypeUrls: Record<AccountType, string> = {
  [AccountType.INDIVIDUAL]:
    '/personal-investing/new-account/setup/account-info/brk-checklist/individual',
  [AccountType.JOINT_TENANT]:
    '/personal-investing/new-account/setup/account-info/brk-checklist/joint',
  [AccountType.OTHER]: '',
  [AccountType.COLLEGE_SAVINGS]: '',
  [AccountType.ROTH_ROLLOVER_IRA]:
    '/personal-investing/new-account/setup/account-info/brk-checklist/roth-rollover-ira',
  [AccountType.TRADITIONAL_IRA]:
    '/personal-investing/new-account/setup/account-info/brk-checklist/traditional-ira',
  [AccountType.ROTH_IRA]:
    '/personal-investing/new-account/setup/account-info/brk-checklist/roth-ira',
  [AccountType.ROLLOVER_IRA]:
    '/personal-investing/new-account/setup/account-info/brk-checklist/rollover-ira',
  [AccountType.EDUCATION_SAVINGS_ACCOUNT]: '',
  [AccountType.UGMA_UTMA]:
    '/personal-investing/new-account/setup/account-info/brk-checklist/ugma-utma',
  [AccountType.TRUST]: '',
  [AccountType.CORPORATE]: '',
  [AccountType.RETIREMENT_PLAN_403]: '',
  [AccountType.RETIREMENT_PLAN_401K]: '',
  [AccountType.RETIREMENT_PLAN_401K_FUND_REACH]: '',
  [AccountType.SEP_IRA]: '',
  [AccountType.SIMPLE_IRA]: '',
  [AccountType.KEOGH]: '',
  [AccountType.PROFIT_SHARING_PLAN]: '',
  [AccountType.MONEY_PURCHASE_PENSION_PLAN]: '',
  [AccountType.RETIREMENT_PLAN_457]: '',
  [AccountType.RETIREMENT_PLAN_401A]: '',
  [AccountType.NON_QUALIFIED_RPS]: '',
  [AccountType.DEFINED_BENEFIT]: '',
  [AccountType.TRANSFER_ON_DEATH]: '',
  [AccountType.NON_PROFIT_ORGANIZATION]: '',
  [AccountType.NON_FIDUCIARY_RETIREMENT_PLAN]: '',
  [AccountType.GUARANTEED_INVESTMENT_CONTRACT]: '',
  [AccountType.SAR_SEP]: '',
  [AccountType.SIM_401K]: '',
  [AccountType.TRADITIONAL_IRA_DECEASED_BENE]: '',
  [AccountType.ROTH_IRA_DECEASED_BENE]: '',
  [AccountType.ROTH_IRA_DECEASED]: '',
  [AccountType.TRADITIONAL_IRA_DECEASED]: '',
  [AccountType.INDIVIDUAL_401K]: '',
  [AccountType.POWER_OF_ATTORNEY]: '',
  [AccountType.ESTATE]: '/content/dam/iinvestor/Forms/broknewacct.pdf',
  [AccountType.RETIREMENT_PLAN_BENE_DUE_TO_DEATH]: '',
  [AccountType.RETIREMENT_PLAN_DECEASED]: '',
  [AccountType.FIS]: '',
  [AccountType.ORGANIZATION]: '',
  [AccountType.RETIREMENT_PLAN]: '',
  [AccountType.JOHN_HANCOCK_GUARDIAN]: '',
  [AccountType.JOHN_HANCOCK_UGMA_UTMA]: '',
  [AccountType.JOHN_HANCOCK_TRUST]: '',
  [AccountType.UNDEFINED]: '',
  [AccountType.INHERITED_IRA]: '/content/dam/iinvestor/Forms/BkgIRANewAct.pdf',
  [AccountType.ROTH_INHERITED_IRA]: '/content/dam/iinvestor/Forms/BkgIRANewAct.pdf',
};

export const AccountTypeDisplayNames: Record<AccountType, string> = {
  [AccountType.INDIVIDUAL]: 'Individual',
  [AccountType.JOINT_TENANT]: 'Joint',
  [AccountType.OTHER]: 'Other Qualified Plan',
  [AccountType.COLLEGE_SAVINGS]: 'College Savings',
  [AccountType.ROTH_ROLLOVER_IRA]: 'Roth Rollover IRA',
  [AccountType.TRADITIONAL_IRA]: 'Traditional IRA',
  [AccountType.ROTH_IRA]: 'Roth IRA',
  [AccountType.ROLLOVER_IRA]: 'Rollover IRA',
  [AccountType.EDUCATION_SAVINGS_ACCOUNT]: 'Education Savings Account',
  [AccountType.UGMA_UTMA]: 'UGMA / UTMA',
  [AccountType.TRUST]: 'Trust',
  [AccountType.CORPORATE]: 'Corporate or other entity',
  [AccountType.RETIREMENT_PLAN_403]: '403B',
  [AccountType.RETIREMENT_PLAN_401K]: '401K',
  [AccountType.RETIREMENT_PLAN_401K_FUND_REACH]: '401K Fund Reach (Non-proto)',
  [AccountType.SEP_IRA]: 'SEP IRA',
  [AccountType.SIMPLE_IRA]: 'Simple IRA',
  [AccountType.KEOGH]: 'Keogh',
  [AccountType.PROFIT_SHARING_PLAN]: 'Profit Sharing Plan',
  [AccountType.MONEY_PURCHASE_PENSION_PLAN]: 'Money Purchase Pension Plan',
  [AccountType.RETIREMENT_PLAN_457]: '457',
  [AccountType.RETIREMENT_PLAN_401A]: '401A',
  [AccountType.NON_QUALIFIED_RPS]: 'Non-Qualified RPS',
  [AccountType.DEFINED_BENEFIT]: 'Defined Benefit',
  [AccountType.TRANSFER_ON_DEATH]: 'Transfer on Death',
  [AccountType.NON_PROFIT_ORGANIZATION]: 'Non Profit Organization',
  [AccountType.NON_FIDUCIARY_RETIREMENT_PLAN]: 'Non-Fiduciary Retirement Plan',
  [AccountType.GUARANTEED_INVESTMENT_CONTRACT]: 'General Investing',
  [AccountType.SAR_SEP]: 'SAR-SEP',
  [AccountType.SIM_401K]: 'SIM-401K',
  [AccountType.TRADITIONAL_IRA_DECEASED_BENE]: 'Traditional IRA Bene due to Death',
  [AccountType.ROTH_IRA_DECEASED_BENE]: 'Roth IRA Bene due to Death',
  [AccountType.ROTH_IRA_DECEASED]: 'Roth IRA Deceased',
  [AccountType.TRADITIONAL_IRA_DECEASED]: 'Traditional IRA Deceased',
  [AccountType.INDIVIDUAL_401K]: 'Individual 401(k)',
  [AccountType.POWER_OF_ATTORNEY]: 'Power of Attorney',
  [AccountType.ESTATE]: 'Estate',
  [AccountType.RETIREMENT_PLAN_BENE_DUE_TO_DEATH]: 'Retirement Plan Bene due to Death',
  [AccountType.RETIREMENT_PLAN_DECEASED]: 'Retirement Plan Deceased',
  [AccountType.FIS]: 'Intermediary/Institutional',
  [AccountType.ORGANIZATION]: 'Organization',
  [AccountType.RETIREMENT_PLAN]: 'Retirement',
  [AccountType.JOHN_HANCOCK_GUARDIAN]: 'John Hancock Guardian',
  [AccountType.JOHN_HANCOCK_UGMA_UTMA]: 'John Hancock UGMA/UTMA',
  [AccountType.JOHN_HANCOCK_TRUST]: 'John Hancock Trust',
  [AccountType.UNDEFINED]: 'Unknown Account Type',
  [AccountType.INHERITED_IRA]: 'Inherited IRA',
  [AccountType.ROTH_INHERITED_IRA]: 'Roth Inherited IRA',
};
export enum TransferTypeValue {
  FullTransfer = 'Full transfer',
  PartialTransfer = 'Partial transfer',
}

export enum TransferFlow {
  Automated = 'Automated',
  Manual = 'Manual',
  AutomatedIncomplete = 'AutomatedIncomplete',
}

export enum HoldingTransferType {
  TOTAL = 'Total',
  PARTIAL = 'Partial',
}
export enum EventType {
  SUCCESS = 'SUCCESS',
  ERROR = 'ERROR',
  CLOSE = 'CLOSE',
  EVENT = 'EVENT',
}
export enum ExternalAccountHolderOwnership {
  'PRIMARY' = 'PRIMARY',
  'JOINT_OWNER' = 'JOINT_OWNER',
}
export enum DocusignEventType {
  SIGNING_COMPLETE = 'signing_complete',
  ACCESS_CODE_FAILED = 'access_code_failed',
  CANCEL = 'cancel',
  DECLINE = 'decline',
  EXCEPTION = 'exception',
  FAX_PENDING = 'fax_pending',
  ID_CHECK_FAILED = 'id_check_failed',
  SESSION_TIMEOUT = 'session_timeout',
  TTL_EXPIRED = 'ttl_expired',
  VIEWING_COMPLETE = 'viewing_complete',
}

export enum RoleType {
  OWNER = 'OWNR',
}

export const partialTransferLabel = 'Partial transfer details';
export const partialTransferMessage = `If you select a partial transfer, you’ll identify the number of shares of
specific holdings within your account at your current provider to transfer
into your T. Rowe Price account. If you’re transferring uninvested cash from
your settlement fund, sweep account or cash account, enter the word “Cash.”`;

export const TRP_INTERNAL_DOMAIN = 'awstrp.net';
